import React, {useState} from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../config';
import ConversationList from './ConversationList';
import Tabs from "../../../../../components-new/ui/Tabs";

/*
 * Inside the white card, so this is a card's padding. What lines the list up
 * with the tables on the other screens is the page inset, and that comes from
 * .dashboard-main - the chat used to add 32px of its own on top of it.
 */
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        padding: 'var(--ds-spacing-xl)',
        paddingTop: 'var(--ds-spacing-md)',
        gap: 'var(--ds-spacing-xl)',
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
    },
    chatContainer: {
        display: 'flex',
        flex: '1 1 auto',
        minHeight: 0,
        overflow: 'hidden',
    },
};

const UserConversationListManager = ({
                                         incomingConversations,
                                         processingConversations,
                                         selectConversation,
                                         selectedConversation,
                                         user,
                                         userData,
                                         openForwardDialog,
                                         forwardConversation,
                                         company,
                                         loadOlderMessages,
                                         clearSelectedConversationFromStore,
                                         features
                                     }) => {
    const [activeTab, setActiveTab] = useState('processing');
    const [direction, setDirection] = useState('forward');

    /* which way the column should come in - the order the tabs sit in */
    const TAB_ORDER = ['incoming', 'processing', 'supervisor'];

    const changeTab = (value) => {
        /*
         * The tab already open is not a move.
         *
         * Clicking it again used to set the direction to 'back' - nothing is
         * greater than itself - and since the column is only rebuilt when the
         * tab changes, the class swapped on the element that was already
         * standing there and the browser replayed the slide on it. The list
         * jumped sideways for no reason, which is what a double click looked
         * like.
         */
        if (value === activeTab) return;

        setDirection(TAB_ORDER.indexOf(value) > TAB_ORDER.indexOf(activeTab) ? 'forward' : 'back');
        setActiveTab(value);
    };

    const viewClasses = 'chat-conversation-list-scroll chat-list-view chat-list-view--' + direction;

    const processingChats = processingConversations.filter(p => p.operatorId != null).filter(p => p.operatorId == userData.id);
    const supervisorChats = processingConversations.filter(p => p.operatorId != null).filter(p => p.operatorId != userData.id);
    const queueChats = incomingConversations.filter(p => p.queued === true)
    // const incomingChats = incomingConversations.filter(p => p.queued !== true)
    const incomingChats = incomingConversations;

    const incomingCount = incomingChats.length;
    const processingCount = processingChats.length;
    const supervisorCount = supervisorChats.length;
    const queueCount = queueChats.length;

    const tabs = [
        // ...(features.includes(config.features.OPERATOR_CONNECT_LOGIC)
        //     ? [{ label: 'queue', value: 'queue', count: queueCount }]
        //     : []),
        { label: 'incomingChats', value: 'incoming', count: incomingCount },
        { label: 'processingChats', value: 'processing', count: processingCount },
        ...(user.authorities.includes(config.rolesMap.owner) ||
        user.authorities.includes(config.rolesMap.admin)
            ? [{ label: 'supervisor', value: 'supervisor', count: supervisorCount }]
            : [])
    ];

    return (
        <div style={styles.container}>
            {/*
              * fluid: three tabs at their natural width do not fit in a column
              * this narrow, so they share it in equal parts. The count is drawn
              * by Tabs itself, outside the part that gets cut short.
              */}
            <Tabs
                selectedTab={activeTab}
                onTabChange={changeTab}
                tabs={tabs}
                fluid
                fontSize="11px"
                variant="underline"
                className="chat-conversation-tabs"
            />

            <div style={styles.chatContainer}>
                {/*{activeTab === 'queue' && (*/}
                {/*    <div style={{height: '100%', overflow: 'auto'}}>*/}
                {/*        <ConversationList*/}
                {/*            id="chat-queue-list"*/}
                {/*            conversationList={queueChats}*/}
                {/*            contactsNameSpace={config.contactsNameSpaces.incomings}*/}
                {/*            selectConversation={selectConversation}*/}
                {/*            selectedConversation={selectedConversation}*/}
                {/*            user={user}*/}
                {/*            openForwardDialog={openForwardDialog}*/}
                {/*            forwardConversation={forwardConversation}*/}
                {/*            company={company}*/}
                {/*            loadOlderMessages={loadOlderMessages}*/}
                {/*            clearSelectedConversationFromStore={clearSelectedConversationFromStore}*/}
                {/*        />*/}
                {/*        <br/>*/}
                {/*        <br/>*/}
                {/*        <br/>*/}
                {/*    </div>*/}
                {/*)}*/}
                {activeTab === 'incoming' && (
                    <div className={viewClasses} key={activeTab}>
                        <ConversationList
                            id="chat-incoming-list"
                            conversationList={incomingChats}
                            contactsNameSpace={config.contactsNameSpaces.incomings}
                            selectConversation={selectConversation}
                            selectedConversation={selectedConversation}
                            user={user}
                            openForwardDialog={openForwardDialog}
                            forwardConversation={forwardConversation}
                            company={company}
                            loadOlderMessages={loadOlderMessages}
                            clearSelectedConversationFromStore={clearSelectedConversationFromStore}
                        />
                        <br/>
                        <br/>
                        <br/>
                    </div>
                )}
                {activeTab === 'processing' && (
                    <div className={viewClasses} key={activeTab}>
                        <ConversationList
                            id="chat-conversations-list"
                            conversationList={processingChats}
                            contactsNameSpace={config.contactsNameSpaces.conversations}
                            selectConversation={selectConversation}
                            selectedConversation={selectedConversation}
                            user={user}
                            openForwardDialog={openForwardDialog}
                            forwardConversation={forwardConversation}
                            company={company}
                            loadOlderMessages={loadOlderMessages}
                            clearSelectedConversationFromStore={clearSelectedConversationFromStore}
                        />
                        <br/>
                        <br/>
                        <br/>
                    </div>

                )}
                {activeTab === 'supervisor' && (
                    <div className={viewClasses} key={activeTab}>
                        <ConversationList
                            id="chat-supervisor-list"
                            conversationList={supervisorChats}
                            contactsNameSpace={config.contactsNameSpaces.conversations}
                            selectConversation={selectConversation}
                            selectedConversation={selectedConversation}
                            user={user}
                            isSupervisor={true}
                            openForwardDialog={openForwardDialog}
                            forwardConversation={forwardConversation}
                            company={company}
                            loadOlderMessages={loadOlderMessages}
                            clearSelectedConversationFromStore={clearSelectedConversationFromStore}
                        />
                        <br/>
                        <br/>
                        <br/>
                    </div>
                )}
            </div>
        </div>
    );
};

UserConversationListManager.propTypes = {
    incomingConversations: PropTypes.array.isRequired,
    processingConversations: PropTypes.array.isRequired,
    selectConversation: PropTypes.func.isRequired,
    selectedConversation: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
};

export default UserConversationListManager;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/UserConversationListManager.jsx